import React, { useState, useEffect } from "react";
import {
  CustomDropdownSelect,
  CustomDatePicker,
  CustomButton,
  SPWrapper,
  Heading,
  CustomLine,
  ButtonRow,
  FlexColumn,
  Row,
  TextLabel,
} from "./MetricDashboard.styles";
import moment from "moment";
import * as dashboardCount from "../../api/metricDashboard/dashboardCount";
import CPNotification from "../Login/CPNotification";
import { Loader } from "@vds/loaders";
import { Wrapper } from "../../constants/common/StyledGlobalConstants";
import VCCPDashboardCount from "./VCCPDashboardCount";
import SupportCaseTypes from "./VCCPButtons/SupportCaseTypes";
import CreatedVSClosed from "./VCCPButtons/CreatedVSClosed";
import { filterDropdownValues, regionFilterDropdownValues } from "../../constants/DropdownConstants";

const VCCPView = (props) => {
  const [chartFilterValue, setChartFilterValue] = useState("1month");
  const [regionFilterValue, setRegionFilterValue] = useState("ALL");
  const [fromDate, setFromDate] = useState("MM/DD/YYYY");
  const [toDate, setToDate] = useState("MM/DD/YYYY");
  const [selectDates, setSelectDates] = useState({ startDate: "", endDate: "" });
  const [notification, setNotification] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [refreshBtn, setRefreshBtn] = useState(false);
  const [dashboardCountData, setDashboardCountData] = useState({});

  useEffect(() => {
    if (fromDate === "MM/DD/YYYY" && toDate === "MM/DD/YYYY") {
      getFilterDashboardCount();
    }
  }, [chartFilterValue, regionFilterValue]);

  const getFilterDashboardCount = async () => {
    setIsLoading(true);
    let responseArray = [];
    try {
      const reqBody = {
        filter: chartFilterValue,
        region: regionFilterValue,
      };
      responseArray = await dashboardCount.dashboardCount(reqBody);
      if (responseArray.data.statusCode === "200" && responseArray.data.data.length !== 0) {
        setDashboardCountData(responseArray.data.data);
        setIsLoading(false);
      } else {
        setIsLoading(false);
        notify("Unable to fetch data due to an unexpected error", "error", true);
      }
    } catch (err) {
      // Log the error for debugging
      console.error("Error fetching dashboard count:", err);
      notify("Unable to fetch data due to an unexpected error", "error", true);
      setIsLoading(false);
      window.scrollTo(0, 0);
    }
    return responseArray;
  };

  const getDateDashboardCount = async () => {
    if (fromDate === "MM/DD/YYYY") {
      notify("Please select From Date", "error", true);
      return;
    }
    if (toDate === "MM/DD/YYYY") {
      notify("Please select To Date", "error", true);
      return;
    }
    setIsLoading(true);
    let responseArray = [];
    try {
      const reqBody = {
        fromDate: moment(fromDate).format("YYYY-MM-DD"),
        toDate: moment(toDate).format("YYYY-MM-DD"),
        region: regionFilterValue,
      };
      setRefreshBtn(true);
      setSelectDates({ startDate: reqBody.fromDate, endDate: reqBody.toDate });
      responseArray = await dashboardCount.dashboardCount(reqBody);
      setIsLoading(false);
      if (responseArray.data.statusCode === "200" && responseArray.data.data.length !== 0) {
        setDashboardCountData(responseArray.data.data);
      } else {
        setIsLoading(false);
        notify("Unable to fetch data due to an unexpected error", "error", true);
      }
    } catch (err) {
      // Log the error for debugging
      console.error("Error fetching dashboard count:", err);
      setIsLoading(false);
      window.scrollTo(0, 0);
      notify("Unable to fetch data due to an unexpected error", "error", true);
    }
    return responseArray;
  };

  const onErrorNotificationClose = () => {
    setNotification(null);
  };

  const notify = (content, type, show) => {
    setNotification(
      <CPNotification isOpen={show} notificationType={type} height="auto" width="98%" closeButton={true} onClose={() => onErrorNotificationClose()}>
        <Wrapper fontFamily="neue-haas-grotesk-text" fontSize="0.875rem">
          {content}
        </Wrapper>
      </CPNotification>
    );
    setTimeout(() => {
      setNotification(null);
    }, 5000);
  };

  const handleCommonFilterValue = (e) => {
    setChartFilterValue(e.target.value);
    setFromDate("MM/DD/YYYY");
    setToDate("MM/DD/YYYY");
    setSelectDates({ startDate: "", endDate: "" });
  };

  const handleRegionList = (e) => {
    let selectRegion = e.target.value.replace(/\s+/g, "");
    setRegionFilterValue(selectRegion);
    if (fromDate !== "MM/DD/YYYY" && toDate !== "MM/DD/YYYY") {
      setSelectDates({ startDate: fromDate, endDate: toDate });
      setRefreshBtn(false);
    }
  };
  const handleFromDate = (e) => {
    let date = moment(e, "MMMM DD,YYYY").format("MM/DD/YYYY");
    setFromDate(date);
  };
  const handleToDate = (e) => {
    let date = moment(e, "MMMM DD,YYYY").format("MM/DD/YYYY");
    setToDate(date);
  };
  const handleRefresh = () => {
    getDateDashboardCount();
  };
  return (
    <SPWrapper>
      <Loader active={isLoading} fullscreen />
      <Row style={{ marginTop: "20px" }}>{notification}</Row>
      <Row style={{ marginTop: "40px" }}>
        <FlexColumn>
          <TextLabel style={{ width: "40%" }}>Filter For</TextLabel>
          <CustomDropdownSelect onChange={(e) => handleCommonFilterValue(e)}>
            {filterDropdownValues.map((item) => {
              if (item.id === 3) {
                return (
                  <option key={item.id} value={item.value} selected>
                    {item.label}
                  </option>
                );
              } else {
                return (
                  <option key={item.id} value={item.value}>
                    {item.label}
                  </option>
                );
              }
            })}
          </CustomDropdownSelect>
        </FlexColumn>
        <FlexColumn>
          <TextLabel style={{ width: "50%", marginLeft: "10px" }}>Region For</TextLabel>
          <CustomDropdownSelect onChange={(e) => handleRegionList(e)}>
            {regionFilterDropdownValues.map((item) => {
              if (item.id === 1) {
                return (
                  <option key={item.id} value={item.value} selected>
                    {item.label}
                  </option>
                );
              } else {
                return (
                  <option key={item.id} value={item.value}>
                    {item.label}
                  </option>
                );
              }
            })}
          </CustomDropdownSelect>
        </FlexColumn>
        <FlexColumn>
          <TextLabel style={{ width: "50%", marginLeft: "10px" }}>From Date</TextLabel>
          <CustomDatePicker
            dateFormat="MM/DD/YYYY"
            surface="light"
            value={fromDate}
            onChange={(e) => handleFromDate(e)}
            width="100%"
            minDate={new Date(1998, 1, 1)}
            maxDate={new Date()}
          />
        </FlexColumn>
        <FlexColumn>
          <TextLabel style={{ width: "35%", marginLeft: "10px" }}>To Date</TextLabel>
          <CustomDatePicker
            dateFormat="MM/DD/YYYY"
            surface="light"
            minDate={new Date(1998, 1, 1)}
            value={toDate}
            onChange={(e) => handleToDate(e)}
            width="100%"
            maxDate={new Date()}
          />
        </FlexColumn>
        <FlexColumn style={{ width: "16%" }}>
          <CustomButton use="secondary" onClick={handleRefresh}>
            Refresh
          </CustomButton>
        </FlexColumn>
      </Row>
      <VCCPDashboardCount dashboardCountData={dashboardCountData} />
      <Heading>Comparison view - Month over Month</Heading>
      <CustomLine type="light"></CustomLine>
      <ButtonRow>
        <div style={{ flex: "1" }}>
          <SupportCaseTypes
            chartFilterValue={chartFilterValue}
            regionFilterValue={regionFilterValue}
            selectFromToDates={selectDates}
            refreshBtn={refreshBtn}
          />
        </div>
        <div style={{ flex: "1" }}>
          <CreatedVSClosed
            chartFilterValue={chartFilterValue}
            regionFilterValue={regionFilterValue}
            selectFromToDates={selectDates}
            refreshBtn={refreshBtn}
          />
        </div>
      </ButtonRow>
    </SPWrapper>
  );
};

export default VCCPView;
